var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15898 13.8666C7.36292 14.0528 7.67918 14.0384 7.86536 13.8345C8.05154 13.6305 8.03714 13.3143 7.8332 13.1281L1.66535 7.49736H15.4961C15.7722 7.49736 15.9961 7.2735 15.9961 6.99736C15.9961 6.72122 15.7722 6.49736 15.4961 6.49736H1.66824L7.8332 0.86927C8.03714 0.68309 8.05154 0.366835 7.86536 0.162895C7.67918 -0.0410457 7.36292 -0.0554433 7.15898 0.130737L0.242631 6.44478C0.102683 6.57254 0.0228539 6.74008 0.00314236 6.91323C-0.0014925 6.94058 -0.00390625 6.96869 -0.00390625 6.99736C-0.00390625 7.02423 -0.00178671 7.05061 0.00229454 7.07633C0.0204692 7.25224 0.100582 7.4229 0.242631 7.55258L7.15898 13.8666Z",
    fill: "#303135"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwardArrow);
export default __webpack_public_path__ + "static/media/backward_arrow.e94a60015fd81d9247f71bbc5004fc8e.svg";
export { ForwardRef as ReactComponent };